import UserSettingsModal from './UserSettingsModal';

export default UserSettingsModal;
